<template>
  <div class="gx-dh">
    <gx-loading :show="loading" />
    <div class="gx-dh__head">
      <h1 class="gx-main__title">抖店优化</h1>
      <!-- <select v-model="activeMerShopId" class="gx-dh__select" @change="changeShop">
        <option value="">请选择店铺</option>
        <option v-for="shop in shopList" :key="shop.mer_shop_id" :value="shop.mer_shop_id">{{ shop.shop_name }}</option>
      </select> -->

       <div class="search-wrap custom-form-wrap">
          <el-form inline size="mini" ref="searchForm">
            <el-form-item label="分组">
              <el-select v-model="activeMerShopId" clearable placeholder="全部分组" class="w200"  @change="changeShop">
                <el-option v-for="g in shopList" :key="g.mer_shop_id" :label="g.shop_name" :value="g.mer_shop_id"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          </div>


    </div>

    <!-- 操作栏 -->
    <div class="gx-dh__operate">
      <div class="gx-dh__hosting">
        <span class="gx-dh__hosting-label">AI生图/主图视频托管</span>
        <button class="gx-dh__switch" :class="{ 'gx-dh__switch--on': videoHostingEnabled }" @click="handleVideoHostingChange(!videoHostingEnabled)">
          <span class="gx-dh__switch-dot"></span>
        </button>
      </div>
      <button class="gx-dh__btn gx-dh__btn--blue" @click="openImgRecord">AI生图/主图视频优化记录</button>
      <div class="gx-dh__title-host">
        <button class="gx-dh__btn gx-dh__btn--blue" @click="changeTitle">标题自动化托管</button>
        <span class="gx-dh__status" :class="{ 'gx-dh__status--off': seo_open_status != 2 }">*标题托管：{{ seo_open_status == 2 ? '已开启' : '未开启' }}</span>
      </div>
    </div>

    <!-- 列表面板：tabs + 批量操作 + 表格 + 分页 -->
    <div class="gx-dh__card">
    <!-- Tabs -->
    <div class="gx-dh__tabs">
      <button
        v-for="t in suggestionTabs"
        :key="t.val"
        class="gx-dh__tab"
        :class="{ 'gx-dh__tab--on': suggestion === t.val }"
        @click="switchSuggestion(t.val)"
      >{{ t.label }}</button>
    </div>

    <!-- 工具栏 -->
    <div class="gx-dh__toolbar">
      <span
        v-if="['suggest_offline', 'force_offline'].includes(suggestion)"
        class="gx-dh__check"
        :class="{ 'gx-dh__check--on': lowAllChecked }"
        @click="toggleLowAll"
      >
        <svg v-if="lowAllChecked" width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#F4F6F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
      </span>
      <button v-if="['suggest_offline', 'force_offline'].includes(suggestion)" class="gx-dh__btn gx-dh__btn--primary" @click="batchOffSaleSelected">
        批量下架（选中{{ checkListLowEffect.length }}件）
      </button>
      <div class="gx-dh__spacer"></div>
      <button class="gx-dh__btn" @click="handleSearchSuggestion">
        <svg width="12" height="12" viewBox="0 0 14 14" fill="none"><path d="M13 7a6 6 0 1 1-1.76-4.24M13 1v4h-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
        刷新
      </button>
    </div>

    <div v-if="['suggest_offline', 'force_offline'].includes(suggestion)" class="gx-dh__warn">
      若商品上架后连续多天未获得有效曝光，可能会被系统自动下架，以释放流量给更优质的商品。
    </div>

    <!-- 商品列表 -->
    <div class="gx-dh__table">
      <table>
        <thead>
          <tr>
            <th class="gx-dh__th-check" style="width: 36px"></th>
            <th>商品</th>
            <th class="gx-dh__th-center">诊断结果</th>
            <th class="gx-dh__th-center" style="width: 200px">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in diagnosisList" :key="row.product_id">
            <td>
              <span class="gx-dh__check" :class="{ 'gx-dh__check--on': checkListLowEffect.includes(row.product_id) }" @click="toggleLowOne(row.product_id)">
                <svg v-if="checkListLowEffect.includes(row.product_id)" width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#F4F6F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
              </span>
            </td>
            <td>
              <div class="gx-dh__goods">
                <span class="gx-dh__thumb"><img v-if="row.main_url" :src="row.main_url" alt="" /><span v-else>🛍️</span></span>
                <div class="gx-dh__goods-body">
                  <div class="gx-dh__goods-name" :title="row.product_name">{{ row.product_name }}</div>
                  <div class="gx-dh__mono gx-dh__dim">ID:{{ row.product_id }}</div>
                </div>
              </div>
            </td>
            <td class="gx-dh__td-center">
              <div v-if="row.suggestion_reason" class="gx-dh__reason">
                <template v-if="row.suggestion_reason.indexOf('opt_white_pic') > -1 || row.suggestion_reason.indexOf('opt_mvideo') > -1">
                  <span v-if="row.suggestion_reason === 'opt_white_pic'" class="gx-dh__reason-tag gx-dh__reason-tag--blue">没有白色底图</span>
                  <span v-if="row.suggestion_reason === 'opt_mvideo'" class="gx-dh__reason-tag gx-dh__reason-tag--blue">没有主图视频</span>
                </template>
                <span v-else-if="row.suggestion_reason.indexOf('duplicate')>-1&&suggestion==='suggest_offline'" class="gx-dh__reason-tag gx-dh__reason-tag--red">重复品</span>
                <span v-else class="gx-dh__reason-tag">{{ row.suggestion_reason }}</span>
              </div>
            </td>
            <td class="gx-dh__td-center">
              <div class="gx-dh__ops">
                <button v-if="['suggest_offline', 'force_offline'].includes(suggestion)" class="gx-dh__op gx-dh__op--danger" @click="handleOffSale(row)">
                  {{row?.suggestion_reason?.indexOf('duplicate')>-1&&suggestion==='suggest_offline'?'一键':''}}下架
                </button>
                <template v-if="suggestion === 'optimize'">
                  <button v-if="row.suggestion_reason.indexOf('opt_white_pic') > -1" class="gx-dh__op gx-dh__op--ok" @click="handleWhitePic">生成白色底图</button>
                  <button v-if="row.suggestion_reason.indexOf('opt_mvideo') > -1" class="gx-dh__op gx-dh__op--ok" @click="handleMvideo">生成主图视频</button>
                </template>
              </div>
            </td>
          </tr>
          <tr v-if="!diagnosisList.length">
            <td :colspan="4" class="gx-dh__empty">暂无低效商品</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 分页 -->
    <div class="gx-dh__pager">
      <div v-if="['suggest_offline', 'force_offline'].includes(suggestion) && checkListLowEffect.length" class="gx-dh__pager-batch">
        <span class="gx-dh__pager-dot"></span>
        <span class="gx-dh__pager-selected">已选择 {{ checkListLowEffect.length }} 件商品</span>
        <button class="gx-dh__btn gx-dh__btn--solid" @click="batchOffSaleSelected">批量下架选中</button>
      </div>
      <!-- <div class="gx-dh__pager-right">
        <span class="gx-dh__pager-total">共 {{ lowPageData.total }} 条</span>
        <page-size-select :value="lowPageData.page_size" :options="pageSizeOptions" @change="onPageSizeChange" />
        <div class="gx-dh__pager-btns">
          <button class="gx-dh__page gx-dh__page--arrow" :disabled="lowPageData.page_no <= 1" @click="getShopProductSuggestionList(lowPageData.page_no - 1)">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M7.5 2.5L4 6l3.5 3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
          </button>
          <button v-for="n in lowPages" :key="n" class="gx-dh__page" :class="{ 'gx-dh__page--on': n === lowPageData.page_no }" @click="getShopProductSuggestionList(n)">{{ n }}</button>
          <button class="gx-dh__page gx-dh__page--arrow" :disabled="lowPageData.page_no >= lowTotalPages" @click="getShopProductSuggestionList(lowPageData.page_no + 1)">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M4.5 2.5L8 6l-3.5 3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
          </button>
        </div>
      </div> -->
      <div style="padding: 10px 14px;width: 100%;text-align: center;">
        <Pagination :total="lowPageData.total" :page.sync="lowPageData.page_no" :limit.sync="lowPageData.page_size" :page-sizes="[10, 20, 50, 100,  200, 300, 400]" @pagination="getShopProductSuggestionList(lowPageData.page_no)"  layout="total, sizes, prev, pager, next, jumper" />
      </div>   
    </div> 
    </div><!-- /gx-dh__card -->

    <!-- Bixi 组件容器 -->
    <div id="huhu"></div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import GxLoading from '../../components/newUi/GxLoading.vue'
import PageSizeSelect from '../../components/newUi/PageSizeSelect.vue'
import gxLoading from '../../mixins/gxLoading'
import Pagination from '../../components/newUi/Pagination.vue'

export default {
  name: 'NewDdHostPage',
  components: { GxLoading, PageSizeSelect, Pagination },  
  mixins: [gxLoading],
  data() {
    return {
      shopList: [],
      activeMerShopId: '',
      oldMerShopId: '',
      suggestion: 'suggest_offline',
      lowPageData: { page_no: 1, page_size: 20, total: 0 },
      pageSizeOptions: [20, 50, 100, 200, 500],
      lowLoading: false,
      diagnosisList: [],
      checkListLowEffect: [],
      videoHostingEnabled: false,
      seo_open_status: 0,
      report: null,
      suggestionTabs: [
        { label: '建议下架', val: 'suggest_offline' },
        { label: '强制下架', val: 'force_offline' },
        { label: '高潜力品', val: 'optimize' }
      ]
    }
  },
  computed: {
    lowTotalPages() {
      return Math.max(1, Math.ceil(this.lowPageData.total / this.lowPageData.page_size))
    },
    lowPages() {
      const total = this.lowTotalPages
      const nums = []
      const start = Math.max(1, Math.min(this.lowPageData.page_no - 2, total - 4))
      for (let i = start; i <= Math.min(total, start + 4); i++) nums.push(i)
      return nums.length ? nums : [1]
    },
    lowAllChecked() {
      return this.diagnosisList.length > 0 && this.diagnosisList.every(row => this.checkListLowEffect.includes(row.product_id))
    }
  },
  created() {
    this.getAuthShopList()
  },
  beforeDestroy() {
    this.shopList.forEach(shop => {
      if (window.ecopen && window.ecopen.__internal_destroy_multi_tea__) {
        window.ecopen.__internal_destroy_multi_tea__(shop.mer_shop_id)
      }
    })
  },
  methods: {
    ...mapActions({
      fetchSingleShopInfo: 'index/fetchSingleShopInfo',
      fetchAuthSuccessShopList: 'ucenter/fetchAuthSuccessShopList',
      fetchShopProductSuggestionList: 'ucenter/fetchShopProductSuggestionList',
      fetchSeoTrusteeshipStrategy: 'ucenter/fetchSeoTrusteeshipStrategy',
      fetchShopHostingInfo: 'ucenter/fetchShopHostingInfo',
      updateMaterialHosting: 'ucenter/updateMaterialHosting',
      opCleanOffline: 'ucenter/opCleanOffline'
    }),
    getAuthShopList() {
      this.fetchAuthSuccessShopList({
        success: (res) => {
          this.shopList = res.data || []
          if (this.shopList.length) {
            this.changeShop(this.shopList[0].mer_shop_id)
          }
        }
      })
    },
    async changeShop(e) {
      if (this.oldMerShopId && window.ecopen && window.ecopen.__internal_destroy_multi_tea__) {
        window.ecopen.__internal_destroy_multi_tea__(this.oldMerShopId)
      }
      this.oldMerShopId = this.activeMerShopId
      this.activeMerShopId = e
      this.getHostStatus()
      this.getSeoHostStatus()
      const data = await this.getToken(this.activeMerShopId)
      window.ecopen.start({
        token: data.token.token,
        appId: data.appId,
        shopId: data.shopId,
        blockedDistributeComponents: [502, 509, 508]
      })
      this.initReport()
      this.handleSearchSuggestion()
    },
    getSeoHostStatus() {
      this.fetchSeoTrusteeshipStrategy({
        data: { mer_shop_id: this.activeMerShopId },
        success: (res) => {
          this.seo_open_status = (res && res.data && res.data.open_status) || 0
        }
      })
    },
    getHostStatus() {
      this.fetchShopHostingInfo({
        data: { mer_shop_id: this.activeMerShopId },
        success: (res) => {
          this.videoHostingEnabled = !!(res && res.data && res.data.is_true)
        }
      })
    },
    getToken(merShopId) {
      return new Promise((resolve) => {
        const ecopenConfigMult = localStorage.getItem('ecopenConfigMult') ? JSON.parse(localStorage.getItem('ecopenConfigMult')) : {}
        const ecopenConfig = ecopenConfigMult[merShopId] ? ecopenConfigMult[merShopId] : {}
        const now = new Date().getTime()
        if (!ecopenConfig.token || ecopenConfig.token.expire_time * 1000 < now) {
          this.fetchSingleShopInfo({
            data: { mer_shop_id: merShopId },
            success: (res) => {
              ecopenConfigMult[merShopId] = res.data
              localStorage.setItem('ecopenConfigMult', JSON.stringify(ecopenConfigMult))
              resolve(res.data)
            }
          })
        } else {
          resolve(ecopenConfig)
        }
      })
    },
    initReport() {
      if (!window.ecopen || !window.ecopen.__internal_multi_tea__) return
      this.report = window.ecopen.__internal_multi_tea__(this.activeMerShopId)
      const nameArr = [1, 6, 7, 2, 3, 4]
      nameArr.forEach(name => {
        this.handleReport('block_view', name)
      })
    },
    handleReport(eventName, name) {
      try {
        if (!this.report) return
        const params = {
          terminal: 'open',
          shop_id: this.activeMerShopId,
          page_name: '杭州云网电子商务有限公司_商品诊断与优化_open',
          name: name
        }
        this.report(eventName, params)
      } catch (error) {
        console.log(error)
      }
    },
    handleVideoHostingChange(val) {
      this.handleReport('bu_general_click', 6)
      this.handleReport('bu_general_click', 7)
      const params = {
        mer_shop_id: this.activeMerShopId,
        status: val ? 1 : 2
      }
      this.updateMaterialHosting({
        data: params,
        success: (res) => {
          if (res.code === 200) {
            this.videoHostingEnabled = val
            this.$message.success(val ? '已开启AI生图/主图视频托管' : '已关闭AI生图/主图视频托管')
          } else {
            this.videoHostingEnabled = !val
            this.$message.error(res.message)
          }
        }
      })
    },
    changeTitle() {
      this.handleReport('bu_general_click', 1)
      window.ecopen.bixi(document.getElementById('huhu'), {
        componentId: 502,
        onClose: () => {
          this.getSeoHostStatus()
        },
        extra: {}
      })
    },
    openImgRecord() {
      window.ecopen.bixi(document.getElementById('huhu'), {
        componentId: 509,
        extra: {}
      })
    },
    switchSuggestion(val) {
      this.suggestion = val
      this.handleSearchSuggestion()
    },
    handleSearchSuggestion() {
      this.lowPageData.page_no = 1
      this.checkListLowEffect = []
      this.getShopProductSuggestionList(1)
    },
    onPageSizeChange(size) {
      this.lowPageData.page_size = size
      this.lowPageData.page_no = 1
      this.getShopProductSuggestionList(1)
    },
    getShopProductSuggestionList(page) {
      this.lowPageData.page_no = page || this.lowPageData.page_no
      const params = {
        mer_shop_id: this.activeMerShopId,
        suggestion: this.suggestion,
        page_no: this.lowPageData.page_no,
        page_size: this.lowPageData.page_size
      }
      this.lowLoading = true
      this.loadingStart()
      this.fetchShopProductSuggestionList({
        data: params,
        success: (res) => {
          this.lowLoading = false
          this.loadingEnd()
          if (res.code === 200) {
            this.diagnosisList = res.data.product_list || []
            this.lowPageData.total = res.data.total || 0
          }
        }
      })
    },
    toggleLowOne(productId) {
      const idx = this.checkListLowEffect.indexOf(productId)
      if (idx > -1) this.checkListLowEffect.splice(idx, 1)
      else this.checkListLowEffect.push(productId)
    },
    toggleLowAll() {
      const pageIds = this.diagnosisList.map(i => i.product_id)
      if (this.lowAllChecked) {
        this.checkListLowEffect = this.checkListLowEffect.filter(i => !pageIds.includes(i))
      } else {
        this.checkListLowEffect = [...new Set([...this.checkListLowEffect, ...pageIds])]
      }
    },
    handleOffSale(item) {
      this.$confirm(`确认下架商品「${item.product_name}」吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.cleanOfflineFun(item.product_id)
      }).catch(() => {})
    },
    batchOffSaleSelected() {
      if (this.checkListLowEffect.length === 0) {
        this.$message.warning('请先选择商品')
        return
      }
      this.$confirm(`确认下架选中的 ${this.checkListLowEffect.length} 件商品吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const ids = this.checkListLowEffect.join(',')
        this.cleanOfflineFun(ids)
      }).catch(() => {})
    },
    cleanOfflineFun(ids){
      const params = {
        mer_shop_id:this.activeMerShopId,
        product_ids:ids
      }
      this.opCleanOffline( {
        data: params,
        success: (res) => {
          if(res.code === 200){
            this.$message.success('下架成功')
            this.handleSearchSuggestion()
          }else {
            this.$message.error(res.message)
          }
        }
      })
    },
    handleWhitePic() {
      this.handleReport('bu_general_click', 4)
      window.ecopen.bixi(document.getElementById('huhu'), {
        componentId: 508,
        extra: {
          batchMaterialInfos: 'no_white_bg_pic'
        }
      })
    },
    handleMvideo() {
      this.handleReport('bu_general_click', 2)
      this.handleReport('bu_general_click', 3)
      window.ecopen.bixi(document.getElementById('huhu'), {
        componentId: 508,
        extra: {
          batchMaterialInfos: 'pic_11_not_full,pic_34_not_full'
        }
      })
    }
  }
}
</script>

<style scoped>
.gx-dh__head {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}
.gx-dh__head .gx-main__title {
  margin: 0;
}
.gx-dh__operate {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background: #FFFFFF;
  border: 1px solid #EBEEF5;
  border-radius: 10px;
  margin-bottom: 16px;
  flex-wrap: wrap;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}
.gx-dh__select {
  height: 32px;
  padding: 0 10px;
  border-radius: 6px;
  border: 1px solid #DCDFE6;
  background: #FFFFFF;
  font-size: 12px;
  color: #303133;
  outline: none;
  min-width: 200px;
  transition: border-color .15s ease;
}
.gx-dh__select:focus {
  border-color: #C8443C;
}
.gx-dh__hosting {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 12px;
  border: 1px solid #A9CBFF;
  background: #EDF4FF;
  border-radius: 8px;
}
.gx-dh__hosting-label {
  font-size: 12px;
  color: #1677FF;
  font-weight: 500;
  white-space: nowrap;
}
.gx-dh__switch {
  width: 36px;
  height: 20px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  background: #DDE2EC;
  position: relative;
  transition: background .2s;
  display: inline-flex;
  align-items: center;
  padding: 0 2px;
  box-sizing: border-box;
  flex-shrink: 0;
}
.gx-dh__switch--on {
  background: #1677FF;
}
.gx-dh__switch-dot {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #FFFFFF;
  box-shadow: 0 1px 3px rgba(0, 0, 0, .2);
  transition: transform .2s;
}
.gx-dh__switch--on .gx-dh__switch-dot {
  transform: translateX(16px);
}
.gx-dh__btn {
  height: 32px;
  padding: 0 15px;
  border-radius: 6px;
  cursor: pointer;
  background: #FFFFFF;
  border: 1px solid #DCDFE6;
  font-size: 12px;
  color: #606266;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  transition: all .15s ease;
  font-weight: 500;
}
.gx-dh__btn:hover:not(:disabled) {
  color: #C8443C;
  border-color: #FFCCC7;
  background: #FFF5F4;
}
.gx-dh__btn:disabled {
  opacity: .5;
  cursor: not-allowed;
}
.gx-dh__btn--blue {
  background: #EDF4FF;
  border-color: #A9CBFF;
  color: #1677FF;
}
.gx-dh__btn--blue:hover:not(:disabled) {
  background: #D6EFFF;
  border-color: #69B1FF;
  color: #1677FF;
}
.gx-dh__btn--primary {
  background: #FFF1F0;
  border: 1px solid #FFCCC7;
  font-weight: 500;
  color: #C8443C;
}
.gx-dh__btn--primary:hover:not(:disabled) {
  background: #FFE5E3;
  border-color: #F5B5B0;
  color: #C8443C;
}
.gx-dh__btn--solid {
  background: #C8443C;
  border-color: #C8443C;
  color: #FFFFFF;
  box-shadow: 0 1px 4px rgba(200, 68, 60, 0.18);
}
.gx-dh__btn--solid:hover:not(:disabled) {
  background: #B23B34;
  border-color: #B23B34;
  color: #FFFFFF;
}
.gx-dh__title-host {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.gx-dh__status {
  display: inline-block;
  font-size: 12px;
  line-height: 28px;
  padding: 0 12px;
  background: #FFF1F0;
  border: 1px solid #FFCCC7;
  color: #C8443C;
  border-radius: 6px;
  white-space: nowrap;
}
.gx-dh__status--off {
  background: #F7F8FA;
  border-color: #DCDFE6;
  color: #909399;
}
/* 列表面板卡片 */
.gx-dh__card {
  border-radius: 10px;
  border: 1px solid #EBEEF5;
  background: #FFFFFF;
  overflow: visible;
  margin-bottom: 16px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.02);
  position: relative;
}
.gx-dh__tabs {
  display: flex;
  margin-bottom: 0;
  overflow-x: auto;
  flex-wrap: nowrap;
  background: #FFFFFF;
  border-radius: 10px 10px 0 0;
  border-bottom: 1px solid #EFE6D2;
  position: relative;
  z-index: 2;
}
.gx-dh__tab {
  padding: 13px 18px 11px;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  background: #FFFFFF;
  font-size: 13px;
  color: #4A4A6A;
  position: relative;
  transition: color .15s ease, border-color .15s ease, background-color .15s ease;
  white-space: nowrap;
  flex-shrink: 0;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
}
.gx-dh__tab:hover {
  color: #C8443C;
  background: transparent;
}
.gx-dh__tab--on {
  background: rgb(255, 245, 245);
  border-bottom-color: #C8443C;
  color: #C8443C;
  font-weight: 600;
  border-radius: 4px 4px 0 0;
}
.gx-dh__tab--on:hover {
  color: #C8443C;
  background: #FDECEB;
}
.gx-dh__toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  background: #FAF6EE;
  border-bottom: 1px solid #EFE6D2;
  margin-bottom: 0;
  flex-wrap: wrap;
}
.gx-dh__toolbar .gx-dh__btn {
  box-shadow: none;
}
.gx-dh__spacer {
  flex: 1;
}
.gx-dh__warn {
  padding: 8px 16px;
  background: #FFFBF0;
  border-bottom: 1px solid #F7EEDD;
  color: #D97706;
  font-size: 12px;
  margin-bottom: 0;
}
.gx-dh__table {
  border-radius: 0;
  overflow: visible;
  border: none;
  margin-bottom: 0;
  background: #FFFFFF;
}
.gx-dh__table table {
  width: 100%;
  border-collapse: collapse;
}
.gx-dh__table th {
  padding: 11px 14px;
  text-align: left;
  background: #FAF6EE;
  font-size: 12px;
  font-weight: 500;
  color: #4A4A6A;
  white-space: nowrap;
  border-bottom: 1px solid #EFE6D2;
}
.gx-dh__table th.gx-dh__th-center,
.gx-dh__table td.gx-dh__td-center {
  text-align: center;
}
.gx-dh__table th:first-child,
.gx-dh__table td:first-child {
  padding-left: 16px;
}
.gx-dh__table td {
  padding: 12px 14px;
  font-size: 12px;
  color: #1A1A2E;
  border-top: 1px solid #EBEEF5;
}
.gx-dh__check {
  width: 15px;
  height: 15px;
  border-radius: 4px;
  border: 1.5px solid #D0D0DD;
  background: #FFFFFF;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all .15s ease;
}
.gx-dh__check:hover {
  border-color: #C8443C;
}
.gx-dh__check--on {
  background: #C8443C;
  border-color: #C8443C;
  box-shadow: 0 1px 3px rgba(200, 68, 60, 0.18);
}
.gx-dh__goods {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  min-width: 260px;
}
.gx-dh__thumb {
  width: 48px;
  height: 48px;
  border-radius: 8px;
  background: linear-gradient(135deg, #F2F3F7, #FFFFFF);
  border: 1px solid #EBEEF5;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  flex-shrink: 0;
  overflow: hidden;
}
.gx-dh__thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.gx-dh__goods-name {
  font-size: 13px;
  color: #1A1A2E;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  max-width: 420px;
}
.gx-dh__mono {
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
}
.gx-dh__dim {
  color: #909399;
}
.gx-dh__reason {
  font-size: 12px;
  color: #606266;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  justify-content: center;
}
.gx-dh__reason-tag {
  display: inline-block;
  padding: 1px 9px;
  border-radius: 4px;
  font-size: 12px;
  line-height: 1.7;
  font-weight: 500;
  background: #FFF7E6;
  color: #FA8C16;
  border: 1px solid #FFD591;
}
.gx-dh__reason-tag--red {
  background: #FFF1F0;
  color: #C8443C;
  border-color: #FFCCC7;
}
.gx-dh__reason-tag--blue {
  background: #EDF4FF;
  color: #1677FF;
  border-color: #A9CBFF;
}
.gx-dh__ops {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  justify-content: center;
}
.gx-dh__op {
  height: 26px;
  padding: 0 12px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 11px;
  border: 1px solid #E4E7ED;
  background: #FFFFFF;
  color: #606266;
  white-space: nowrap;
  transition: all .15s;
}
.gx-dh__op:hover {
  color: #C8443C;
  border-color: #FFCCC7;
  background: #FFF5F4;
}
.gx-dh__op--danger {
  background: #FFF1F0;
  border-color: #FFCCC7;
  color: #C8443C;
}
.gx-dh__op--danger:hover {
  background: #FFE5E3;
  border-color: #F5B5B0;
  color: #C8443C;
}
.gx-dh__op--ok {
  background: #EDF4FF;
  border-color: #A9CBFF;
  color: #1677FF;
}
.gx-dh__op--ok:hover {
  background: #D6EFFF;
  border-color: #69B1FF;
  color: #1677FF;
}
.gx-dh__empty {
  text-align: center;
  padding: 52px 0 !important;
  color: #909399;
}
.gx-dh__pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 12px 16px;
  border-top: 1px solid #EFE6D2;
  background: #FAF6EE;
  border-radius: 0 0 10px 10px;
}
.gx-dh__pager-batch {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.gx-dh__pager-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #C8443C;
  flex-shrink: 0;
}
.gx-dh__pager-selected {
  font-size: 12px;
  color: #C8443C;
  font-weight: 500;
  white-space: nowrap;
}
.gx-dh__pager-right {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-left: auto;
}
.gx-dh__pager-total {
  font-size: 12px;
  color: #606266;
}
.gx-dh__pager-btns {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
}
.gx-dh__page {
  min-width: 30px;
  height: 30px;
  padding: 0 8px;
  border-radius: 6px;
  border: 1px solid #E4E7ED;
  background: #FFFFFF;
  cursor: pointer;
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  color: #606266;
  transition: all .15s ease;
}
.gx-dh__page:hover:not(:disabled) {
  border-color: #C8443C;
  color: #C8443C;
}
.gx-dh__page:disabled {
  opacity: .5;
  cursor: not-allowed;
}
.gx-dh__page--on {
  background: #C8443C;
  border-color: #C8443C;
  color: #FFFFFF;
  font-weight: 700;
  box-shadow: 0 1px 4px rgba(200, 68, 60, 0.18);
}
.gx-dh__page--arrow {
  padding: 0;
  min-width: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>
